module.exports = __webpack_public_path__ + "images/bannerES-8d7850604156c2a7e1104c3b3b018c40.png";